import { SessionStorage } from 'types/SessionStorage'

export const mockSessionStorageR: SessionStorage = {
}
